<template>
  <div id="toolbar-main">

    <v-navigation-drawer
      temporary
      clipped
      v-model="drawer"
      disable-resize-watcher
      id="side-nav-drawer"
      hide-overlay
      width="225"
      fixed
      app
    >
      <side-nav-drawer :authUser="userIsAuthenticated" :userName="username"></side-nav-drawer>
    </v-navigation-drawer>

    <!-- TOOLBAR -->
    <v-toolbar
      app
      fixed
    >
      <!-- NAV DRAWER -->
      <v-toolbar-side-icon @click.native.stop="drawer=!drawer"><v-icon>{{ toggleMenu }}</v-icon></v-toolbar-side-icon>


      <!-- CENTER -->
      <v-toolbar-title class="text-xs-center">
        <router-link :to="iconLink"><v-avatar tile><img src="../../assets/Ammonyte_Logo-13.png" style="max-height:45px;width:auto;"></v-avatar></router-link>
      </v-toolbar-title>
      <v-toolbar-title>{{ toolbarTitle }}</v-toolbar-title>

      <v-spacer></v-spacer>
      
      <!-- RIGHT SIDE -->
      <div class="text-xs-center">
        <v-menu offset-y>
          <v-btn
            icon
            flat
            dark
            slot='activator'
          >
            <v-icon medium>mdi mdi-dots-vertical</v-icon>
          </v-btn>
          <v-list style="color:white">
            <v-list-tile
              v-for="item in menuItems" :key="item.title"
              :to="{path: item.link}"
            >
              <v-list-tile-action><v-icon>{{ item.action }}</v-icon></v-list-tile-action>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="userIsAuthenticated" @click="onLogout">
              <v-list-tile-action><v-icon>mdi mdi-logout</v-icon></v-list-tile-action>
              <v-list-tile-title>Logout</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>

    </v-toolbar>

  </div>
</template>

<script>
import SideNavDrawer from './SideNavDrawer.vue'

export default {
  components: {
    'side-nav-drawer': SideNavDrawer
  },
  
  data() {
    return {
      drawer: false,
      mini: true,
      user_name: 'Member',
      extend: true
    }
  },
  props: [
    'toolbarTitle',
    'extension'
  ],

  computed: {
    // Populate menu items based on if user is logged in
    menuItems() {
      let menuItems = [
        { title: 'Login', action: 'mdi mdi-login', link: '/login' },
        // { title: 'Signup', action: 'mdi mdi-account-plus', link: '' }
      ]
      if ( this.userIsAuthenticated ) {
        menuItems = [
          { title: "Profile", action: "mdi mdi-account-box", link: "/profile" },
        ]
      }
      return menuItems
    },
    // Return true if user is not null nor undefined
    userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    toggleMenu() {
      return (!this.drawer) ? 'menu' : 'chevron_left'
    },
    username() {
      // return (this.userIsAuthenticated) ? this.$store.getters.username : this.user_name
      return this.getUsername()
    },
    iconLink() {
      return (this.userIsAuthenticated) ? '/dashboard' : '/'
    },
    isExtended() {
      return (this.extension !== null && this.extension !== '')
    }
  },

  watch: {
    user( value ) {
      if ( value !== null && value !== undefined ) {
        this.user_name = this.username()
        this.$router.push('/home')
      }
    }
  },

  methods: {
    onLogout() {
      this.$store.dispatch( 'logout' )
      this.$router.push('/')
    },
    getUsername() {
      return (this.userIsAuthenticated) ? this.$store.getters.username : this.getEmail().split('@')[0]
      // var uname = this.$store.getters.username
      // return (uname !== null && uname !== undefined) ? uname : this.getEmail().split('@')[0]
    },
    getEmail: function () {
      return (this.userIsAuthenticated) ? this.$store.getters.email : 'username@email.com'
    }
  },

  name: 'ToolbarMain'
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/Toolbar.vue